module.exports = __webpack_public_path__ + "static/media/user-icon.832f182e.svg";